module.exports = __webpack_public_path__ + "img/close.b1cba424.svg";